
export let dec2hex = (dec) => {

    return dec.toString(16).padStart(2, '0');
};

export let generateId = (len) => {

    let arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);

    return Array.from(arr, dec2hex).join('');

};

export const translations = {
    'pending': 'Ausstehend',
    'completed': 'Abgeschlossen',
    'active': 'Aktiv',
    'inactive': 'Inaktiv',
    'blocked': 'Blockiert'
};

export const errorReasons = {
    'not_found': 'Account existiert nicht',
    'inactive': 'Bitte kontaktieren Sie unseren Support',
    'not_native': 'TODO',
    'password_incorrect': 'Falsches Passwort',
    'ratelimit': 'Bitte versuchen Sie es später nochmals',
    'fill_fields': 'Bitte füllen Sie alle Felder aus',
    'invalid_email': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
    'missing_params': 'Unerwarteter Fehler aufgetreten',
    'email_exists': 'Account mit dieser E-Mail-Adresse existiert bereits',
    'password_length': 'Mindestlänge Passwort sind 8 Zeichen',
    'code_length': 'Code muss 4 Zeichen lang sein',
    'unexpected_error_plans': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später nochmals.',
    'no_available': 'Sie können keine weiteren Locations registrieren',
    'no_integrations': 'Bitte verlinken Sie mindestens ein Portal',
    'max_integrations': 'Sie haben Ihre maximale Anzahl an verlinkten Portalen erreicht',
    'iban_length': 'Mindestlänge Iban sind 21 Zeichen',
    'incorrect': 'Falscher Code',
    'userEmailExists': 'User mit dieser Email existiert bereits'
};

export const USER_STATUS_TEXT = {
    'pending': 'Ausstehend',
    'active': 'Aktiv',
    'inactive': 'Inaktiv',
    'blocked': 'Blockiert'
};

export const ERROR_DISAPPEAR_AFTER = 5500;
